import { type DetailedHTMLProps, forwardRef } from 'react'
import { cn } from 'tailwind-ui'

export const ScrollArea = forwardRef<
  HTMLDivElement,
  DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
>(({ className, ...rest }, ref) => {
  return (
    <div
      {...rest}
      ref={ref}
      className={cn(
        'scrollarea scroller min-h-full !overflow-y-auto',
        className
      )}
    />
  )
})
